import { initCommentTextOverride } from './comment-form/js';

export const initKijSubModules = () => {
  initCommentTextOverride();
};
